<template>
    <div v-if="isVisible" class="modal-overlay">
        <div class="modal">
            <div class="modal-header">
                <h3>{{ title }}</h3>
                <button @click="closeModal" class="btn-close">&times;</button>
            </div>
            <div class="modal-body">
                <div class="form-create">
                    <form @submit.prevent="CreateContract">
                        <div>
                            <label>Nutzer</label>
                            <select v-model="user" required>
                                <option disabled value="">Please select one</option>
                                <option v-for="(user, index) in getUserData().allUsers" :key="index"> {{ user }}</option>
                            </select>
                        </div>
                        <div>
                            <label>Start Datum</label>
                            <input type="date" v-model="contractStart" required>
                        </div>
                        <div>
                            <label>Wochenstunden</label>
                            <input type="number" v-model="weeklyWorkHours" required>
                        </div>
                        <div>
                            <label>Urlaubstage</label>
                            <input type="number" v-model="holidays" required>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" @click="CreateContract">Speichern</button>
                <button @click="closeModal">Schließen</button>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/service';

export default {
    name: 'createModal',
    props: {
        title: {
            type: String,
            default: 'Modal Title',
        },
        show: {
            type: Boolean,
            default: false,
        },
        latestCreate: {
            type: Object,
            default: () => ({
                user: '',
                contractStart: '',
                weeklyWorkHours: '',
                holidays: '',
            })
        },
    },
    data() {
        return {
            user: this.latestCreate.user,
            contractStart: this.latestCreate.contractStart,
            weeklyWorkHours: this.latestCreate.weeklyWorkHours,
            holidays: this.latestCreate.holidays,
        };
    },
    computed: {
        isVisible() {
            return this.show;
        },
    },
    watch: {
        isVisible(val) {
            if (val) {
                this.initializeData();
            }
        }
    },
    methods: {
        getUserData() {
            var jsonString = localStorage.getItem('userData');
            return jsonString ? JSON.parse(jsonString) : null;
        },
        closeModal() {
            this.$emit('close');
        },
        update() {
            this.$emit('update');
            this.closeModal();
        },
        initializeData() {
            this.user = this.latestCreate.user || '';
            this.contractStart = this.latestCreate.contractStart || '';
            this.weeklyWorkHours = this.latestCreate.weeklyWorkHours || '';
            this.holidays = this.latestCreate.holidays || '';
        },
        CreateContract() {
            apiService.post(`/ContractAdmin/CreateContract`,{
                user:  this.user,
                startDate: this.contractStart.toJSON(),
                weeklyWorkHours: this.weeklyWorkHours,
                holidays: this.holidays
            })
                .then(() => {
                    this.update();
                }).catch(() => {
                    console.log("CreateContract Error!");
                }).finally(() => {
                    console.log("CreateContract Finally!");
                })
        }
    },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal {
    background: #fff;
    padding: 2rem;
    border-radius: 5px;
    width: 600px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-body {
    margin: 15px 0;
}

.btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #4d4d4d;
}

.btn-close:hover {
    color: #c0c0c0;
}

.form-create {
    margin: auto;
    /* width: 30%; */
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.form-create h2 {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 1rem;
}

.form-create form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.form-create label,
.form-create input,
.form-create select {
    display: block;
    width: 100%;
}

.form-create input,
.form-create button,
.form-create select {
    padding: .5rem .75rem;
}

.form-create label {
    margin-bottom: .5rem;
    font-weight: 600
}

.form-create input:focus-visible,
.form-create select:focus-visible {
    outline: 3px solid #5b97d484;
    border-radius: 2px;
}

.modal-footer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.modal-footer button {
    border: none;
    background-color: #4d4d4d;
    border-radius: 5px;
    font-size: 1rem;
    color: white;
    font-weight: 600;
    padding: .5rem .75rem;
}

.modal-footer button:hover {
    cursor: pointer;
    background-color: #c0c0c0;
}
</style>